import React from "react";
import ProductCard from "./ProductCard";
import card1Img from "../../../images/img-3.jpg";
import card2Img from "../../../images/img-4.jpg";
import card3Img from "../../../images/img-5.jpg";
import card4Img from "../../../images/img-6.jpg";
import card5Img from "../../../images/img-7.jpg";
import card6Img from "../../../images/img-8.jpg";
import card7Img from "../../../images/img-9.jpg";
import "../Cards.css";

function ProductCardGrid() {
  return (
    <div className="cards">
      <div className="cards__container">
        <div className="cards__wrapper">
          <ul className="cards__items">
            <ProductCard
              src={card2Img}
              header="CemLife"
              // Программное обеспечение для расчетов при цементировании. Позволяет снизить риск инцидентов при сооружении нефтегазовых скважин. Разработано при участии инженеров высочайшего класса.
              text="Software for cementing calculations. Helps reduce the risk of incidents during oil and gas well construction. Developed with the participation of top-class engineers."
              path="/cem-life#cem-life"
            />
            <ProductCard
              src={card3Img}
              header="CemTest"
              // Информационная система для автоматизации лаборатории. Система представляет собой программное обеспечение, разработанное специально для автоматизации процессов в лабораториях, занимающихся тампонажными растворами.
              text="Information system for laboratory automation. The software is developed specifically for automating processes in laboratories dealing with grouting solutions."
              path="/cem-test#cem-test"
            />
            <ProductCard
              src={card1Img}
              header="True sight"
              // Современное и точное оборудование тестирования цементного камня, позволяющее с высокой точностью воспроизвести реальные скважинные условия.
              text="Modern and accurate cement stone testing equipment that allows highly accurate reproduction of real well conditions."
              path="/ts400#ts400"
            />
          </ul>
          <ul className="cards__items">
            <ProductCard
              src={card4Img}
              header="Engineering Support"
              // Инженерное сопровождение
              // Наш персонал на 90% состоит из инженеров высочайшего класса, которые могут предоставить Вам расчеты и инженерные решения для любой задачи.
              text="Our staff consists of 90% top-class engineers who can provide you with calculations and engineering solutions for any task."
              path="/engineering-support#engineering-support"
            />
            {/*<ProductCard
              src={card5Img}
              header="Repair and Insulation Works"
              // Ремонтно-изоляционные работы
              // Использование уникальной формулы позволит прослужить вашей скважине еще долгие годы
              text="The use of a unique formula will allow your well to last for many more years"
              path="/"
            />*/}
            <ProductCard
              src={card6Img}
              header="Cementing Heads"
              // Цем. головы
              // Новейшее оборудование позволит Вам добиться максимального качества выполняемых операций и снизить риски и затраты на проведение ремонтных работ.
              text="The latest equipment will allow you to achieve maximum quality of operations and reduce the risks and costs of repair work."
              path="/cem-heads#cem-heads"
            />
            <ProductCard
              src={card7Img}
              header="Staff Training"
              // Обучение персонала
              // Наши лучшие специалисты с многолетним опытом работы в ведущих сервисных компаниях предоставляют услуги по проведению технических консультаций в области наклонно-направленного бурения скважин, крепления обсадных колонн, буровых растворов, ГРП и супервайзинга в бурении.
              text="Our best specialists with many years of experience in leading service companies provide technical consultation services in the field of directional drilling, casing running, drilling fluids, hydraulic fracturing, and drilling supervision."
              path="/staff-training#staff-training"
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ProductCardGrid;
